import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { BasicHeader } from '../../components/basic_header';
import ErrorWrapper from '../../lib/error_wrapper';
import { NetworkDelaySearch } from '../../lib/util';
import { Input, Table, Button } from 'antd';
import { Link } from 'react-router-dom';


const queryString = require('query-string');


class FailedTransactionList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            filter_query: {}
        }

        this.listDataExecutor = RESTExecutor.list().config({
            label: 'list'
        }).connect(props.domains.failedTransaction);

        // this.listDataExecutor.execute()

        this.delay_search = new NetworkDelaySearch();

    }


    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }
    render() {

        let listDataExecutor_resp = this.listDataExecutor.response()
        const {filter_query}=this.state;
        let rowsData = (listDataExecutor_resp.result&&listDataExecutor_resp.result.rows )|| [];
        let rowsMeta = listDataExecutor_resp.meta || {};
        return (
            <div>
                <BasicHeader
                    menu_items={[]} no_back
                    title="Failed Transaction List"
                />
                 <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                            }} autoFocus
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {

                                            this.props.history.push({
                                                // pathname:"users",
                                                search: queryString.stringify({ ...this.state.filter_query })
                                            })
                                        })

                                    }
                                })
                            }} />
                    </div>
                </div>
                
                <ErrorWrapper
                error={listDataExecutor_resp}
                onReload={()=>{
                    this.listDataExecutor.execute()
                }}
                >
                     <div className='default-card' style={{
                    // padding: 8
                }}>
                     <Table
                        // rowClassName='hand-cursor'
                        className='main-table noHover'
                        loading={listDataExecutor_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={false}
                        // pagination={{
                        //     // simple: true,
                        //     position:'bottom',
                        //     onChange: (current, size) => {
                        //         this.props.history.push({
                        //             search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                        //         })

                        //     },
                        //     defaultCurrent: 1,
                        //     current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                        //     // defaultPageSize: 20,
                        //     pageSize: (rowsMeta && rowsMeta.requested_count),

                        //     total: (rowsMeta && rowsMeta.total_count),
                        //     showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        // }}
                        rowKey={(record) => record.id}
                        columns={[
                            {
                               title:"Name",
                               dataIndex:'name',
                               width:300,
                               key:'name'

                            },
                            { 
                                title:"Description",
                                dataIndex:'description',
                                key:'description'
                            },
                            {
                                title: "", dataIndex: "id", 
                                width:80,
                                key: 'id', render: (id) => {
                                    return <div style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        alignItems:'center'
                                    }}> 
                                    {/* <Link to={{
                                        pathname: `/activity/cache/${id}`,
                                        // search: `datatype=${id}`
                                    }}
                                    style={{color:'inherit'}}
                                    >
                                        <Button type='link'>View</Button>
                                    </Link>
                                         */}

                                    </div>
                                }
                            }
                        ]}
                        dataSource={rowsData}
                    />
                    </div>
                </ErrorWrapper>
            </div>
        );
    }

    componentDidMount() {
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                ...new_filter_query
            }
        }, () => {
            this.listDataExecutor.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    }

    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    ...new_filter_query
                }
            }, () => {
                this.listDataExecutor.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } 


    }

}

export default withDomains(FailedTransactionList, "failedTransaction");
